import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "../data/siteData";

export default function useAdminAccess() {
  const navigate = useNavigate();
  const [state, setState] = useState("loading");

  useEffect(() => {
    let active = true;

    async function verifyAccess() {
      try {
        const response = await fetch(`${API}/auth/me`, { credentials: "include" });
        const user = response.ok ? await response.json() : null;
        if (!user || user.role !== "admin") throw new Error();
        if (active) setState("ready");
      } catch {
        navigate("/admin-login", { replace: true });
      }
    }

    verifyAccess();
    return () => {
      active = false;
    };
  }, [navigate]);

  return state;
}